"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adjustArrowAlign = adjustArrowAlign;
exports.isReachLimit = isReachLimit;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _dom = _interopRequireDefault(require("../tooltip/dom"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* istanbul ignore file */
function getWH(element, props) {
  return _dom.default.getWH(element, props);
}
/**
 * 是否是左右方向
 * @param points
 */
function isLrDirection(points) {
  var sourceDir = points[0];
  var targetDir = points[1];
  var LR_REG = /^[ctb][rl]$/; // 左右
  // 两者第一个字符都是一样的
  return LR_REG.test(sourceDir) && LR_REG.test(targetDir) && sourceDir.charAt(0) === targetDir.charAt(0);
}
/**
 * 是否是上下方向
 * @param points
 */
function isTbDirection(points) {
  var sourceDir = points[0];
  var targetDir = points[1];
  var TB_REG = /^[bt][clr]$/; // 上下
  // 两者第二个字符都是一样的
  return TB_REG.test(sourceDir) && TB_REG.test(targetDir) && sourceDir.charAt(1) === targetDir.charAt(1);
}
/**
 * 获取第一个overflow不为visible的父元素
 * @param element
 */
function getFirstNotVisiableElem(element) {
  if (element.parentNode && element.parentNode.nodeType === 9) {
    return document.body;
  }
  if (window.getComputedStyle(element).overflow === 'visible') {
    if (element.parentNode) {
      return getFirstNotVisiableElem(element.parentNode);
    }
    return element;
  }
  return element;
}
/**
 * 判断element是否在containr的边界
 * 左右 上下边界
 * @param element
 * @param container
 * @param popNodeAlign
 * @returns {boolean}
 */
function isReachLimit(element, container, _ref) {
  var popNodeAlign = _ref.popNodeAlign;
  // popLayer的大小信息
  var elementPos = _dom.default.getOffset(element);
  var elementRect = {
    width: getWH(element, 'width'),
    height: getWH(element, 'height'),
    left: elementPos.left,
    top: elementPos.top
  };
  // alignContainer的大小信息
  var viewport;
  if (container === window) {
    // 视口
    viewport = {
      width: getWH(window, 'width'),
      height: getWH(container, 'height'),
      left: 0,
      top: 0,
      borderLeft: 0,
      borderRight: 0,
      borderTop: 0,
      borderBottom: 0
    };
  } else {
    /*
     * 父元素
     * domalign定位时会自动向上找第一个为overflow hidden/auto的元素作为定位边界
     * 所以需要找出真实定位的父元素
     */
    var domAlignContainer = getFirstNotVisiableElem(container);
    var style = getComputedStyle(domAlignContainer);
    var pos = _dom.default.getOffset(domAlignContainer);
    viewport = {
      width: getWH(domAlignContainer, 'width'),
      height: getWH(domAlignContainer, 'height'),
      left: pos.left,
      top: pos.top,
      borderLeft: parseFloat(style.borderLeftWidth),
      borderRight: parseFloat(style.borderRightWidth),
      borderTop: parseFloat(style.borderTopWidth),
      borderBottom: parseFloat(style.borderBottomWidth)
    };
  }
  /*
   * 在popLayer达到边界时，判断是否需要重新定位
   * 左右位置时，
   */
  if (isLrDirection(popNodeAlign.points)) {
    // 到达 上下 边界
    if (elementRect.top === viewport.top + viewport.borderTop || elementRect.top + elementRect.height + viewport.borderBottom === viewport.top + viewport.height) {
      return true;
    }
    return false;
  }
  // 上下位置时，
  if (isTbDirection(popNodeAlign.points)) {
    // 到达 左右 边界
    if (elementRect.left === viewport.left + viewport.borderLeft || elementRect.left + elementRect.width + viewport.borderRight === viewport.left + viewport.width) {
      return true;
    }
    /*
     * target宽度过小
     * 目标元素实际内容宽度小于32
     * if (getWH(targetNode, "width") <= MIN_TARGETNODE_LENGTH) {
     *   return true;
     * }
     */
  }
  return false;
}
/**
 * 根据已经定位的popLayer的定位信息，得到三角的定位位置
 * @param popMessageAlign
 */
function adjustArrowAlign(popMessageAlign) {
  // t l r b
  var direction = null;
  var offset = [0, 0]; // 定位偏移量
  var points = ['', ''];
  var arrowOffset = 2.26; // poplayer与target的距离8.2 - 边长/2 * 2^0.5
  var newPoints = popMessageAlign.points;
  // 左右
  if (isLrDirection(newPoints)) {
    if (/^[ctb][r]$/.test(newPoints[0])) {
      points = ['cr', 'cl'];
    }
    if (/^[ctb][l]$/.test(newPoints[0])) {
      points = ['cl', 'cr'];
    }
    direction = points[0].charAt(1);
  }
  // 上下
  if (isTbDirection(newPoints)) {
    if (/^[b][clr]$/.test(newPoints[0])) {
      points = ['bc', 'tc'];
    }
    if (/^[t][clr]$/.test(newPoints[0])) {
      points = ['tc', 'bc'];
    }
    direction = points[0].charAt(0);
  }
  // offset
  if (direction === 't') {
    offset = [0, arrowOffset];
  }
  if (direction === 'b') {
    offset = [0, -arrowOffset];
  }
  if (direction === 'l') {
    offset = [arrowOffset, 0];
  }
  if (direction === 'r') {
    offset = [-arrowOffset, 0];
  }
  return _objectSpread(_objectSpread({}, popMessageAlign), {}, {
    offset: offset,
    points: points
  });
}